import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Table, Spinner } from 'react-bootstrap';
import '../Dashboard/admindashboard.css';

import Navbar1 from './Navbar1';
import Sidebar from './Sidebar';

function AdminDashboard() {
  const [userProfiles, setUserProfiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUserProfiles();
  }, []);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  function formatDateToYYYYMMDD(dateString) {
    const originalDate = new Date(dateString);
    const year = originalDate.getUTCFullYear();
    const month = String(originalDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(originalDate.getUTCDate()).padStart(2, '0');  // + 1
    return `${year}-${month}-${day}`;
  }

  function arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  const fetchUserProfiles = async () => {
    try {
      const response = await axios.get('https://main-lms-backend-1.onrender.com/leaveapplications');
      const sortedData = response.data.sort((a, b) => {
        // Convert startdate strings to Date objects for comparison
        const dateA = new Date(b.applied_leave_dates);
        const dateB = new Date(a.applied_leave_dates);
        // Sort by descending order (most recent date first)
        return dateA - dateB;
      });
      setUserProfiles(sortedData);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching user profiles:', error);
      setLoading(false);
    }
  };

  const handleApprove = async (userId, date, email,daysofleave) => {
    try {
      const formattedDate = formatDateToYYYYMMDD(date);
      await axios.put(`https://main-lms-backend-1.onrender.com/leaveapplications/approve/${userId}`, { date: formattedDate, email: email,daysofleave:daysofleave });
      fetchUserProfiles();
      alert(`Leave application for user with Employee Code ${userId} has been approved.`);
    } catch (error) {
      console.error(`Error approving leave application with ID ${userId}:`, error);
    }
  };

  const handleReject = async (userId, date, email,daysofleave) => {
    try {
      const formattedDate = formatDateToYYYYMMDD(date);
      await axios.put(`https://main-lms-backend-1.onrender.com/leaveapplications/reject/${userId}`, { date: formattedDate, email: email,daysofleave: daysofleave });
      fetchUserProfiles();
    } catch (error) {
      console.error(`Error rejecting leave application with ID ${userId}:`, error);
    }
  };

  const isStartDateInPast = (startDate) => {
    const today = new Date();
    const start = new Date(startDate);

    // Adjust to compare only dates without time
    const todayWithoutTime = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const startWithoutTime = new Date(start.getFullYear(), start.getMonth(), start.getDate());

    return startWithoutTime < todayWithoutTime;
};

  return (
    <>
      <Navbar1 />
      <div className="admin-dashboard">
        <Sidebar />
        <div className="leave-applications">
          <h2>Leave Applications</h2>
          {loading ? (
            <Table striped bordered hover>
              <tbody>
                <tr>
                  <td colSpan="10">Loading...</td>
                </tr>
              </tbody>
            </Table>
          ) : userProfiles.length === 0 ? (
            <Table striped bordered hover>
              <tbody>
                <tr>
                  <td colSpan="10">No leave requests found.</td>
                </tr>
              </tbody>
            </Table>
          ) : (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Emp Code</th>
                  <th>Profile</th>
                  <th>Name</th>
                  {/* <th>Email</th> */}
                  <th>Applied Date</th>
                  <th>Leave Type</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Days of leave</th>
                  {/* <th>Days Duration</th> */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {userProfiles.map(profile => (
                  <tr key={profile.id}>
                    <td>{profile.emp_code}</td>
                    <td className="text-center">
                      <div className="profile-avatar-1">
                        {profile && profile.data && (() => {
                          const base64String = arrayBufferToBase64(profile.data.data);
                          return <img className='pro-1' src={`data:image/png;base64,${base64String}`} />;
                        })()}
                      </div>
                    </td>
                    <td>{profile.name}</td>
                    {/* <td>{profile.email}</td> */}
                    <td>{formatDate(profile.applied_leave_dates)}</td>
                    <td>{profile.leavetype}</td>
                    <td>{formatDate(profile.startdate)}</td>
                    <td>{formatDate(profile.enddate)}</td>
                    <td>{profile.daysofleave}</td>
                    {/* <td>{profile.leave_duration}</td> */}
                    <td>
                      <Button
                        variant="success"
                        onClick={() => handleApprove(profile.emp_code, profile.applied_leave_dates, profile.email,profile.daysofleave)}
                        disabled={profile.status === 'Approved' || isStartDateInPast(profile.startdate)}
                      >
                        Approve
                      </Button>{' '}
                      <Button
                        variant="danger"
                        onClick={() => handleReject(profile.emp_code, profile.applied_leave_dates, profile.email,profile.daysofleave)}
                        disabled={profile.status === 'Rejected' || isStartDateInPast(profile.startdate)}
                      >
                        Reject
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </div>
    </>
  );
}

export default AdminDashboard;
